/**
 * @description 对账
 */
import RECONCILIATION from '@/api/module/reconciliation';

const RECONCILIAT = {
  namespaced: true,
  state: {
    tableData: [], //对账列表
    // 这是 map 数据
    rightListMap: {
      // eslint-disable-next-line 
      对账批次数: { text: 1000, unit: '条' },
      // eslint-disable-next-line
      对账异常数: { text: 1000, unit: '条' },
    },
    params: {
      pageNum: 1,
      pageSize: 10,
      total: 0,
    }, //翻页
    recDetailTable: {}, //详情
  },
  mutations: {
    // 对账列表
    settableData(state, data = {}) {
      data.records.map(item => {
        item.channel = item.channel === 'WECHAT' ? '微信' : item.channel === 'ALIPAY' ? '支付宝' : '银联';
        item.results = item.results === 'SUCCESS' ? '正常' : item.results === 'FAIL' ? '异常' : '对账中';
        item.contrastAmount = item.contrastAmount.toFixed(2);
        item.errorAmount = item.errorAmount.toFixed(2);
      });
      for (let key in state.rightListMap) {
        if (key === '对账批次数') {
          state.rightListMap[key].text = data.total;
        } else {
          state.rightListMap[key].text = data.current;
        }
      }
      state.tableData = data.records;
      state.params.total = data.total;
    },
    // 对账详情
    setrecDetailTable(state, data = {}) {
      data.channel = data.channel === 'WECHAT' ? '微信' : data.channel === 'ALIPAY' ? '支付宝' : '银联';
      data.results = data.results === 'SUCCESS' ? '对账正常' : data.results === 'FAIL' ? '对账异常' : '对账中';
      for (let key in data) {
        if (
          key === 'channelTradeAmount' ||
          key === 'channelPayAmount' ||
          key === 'channelRefundAmount' ||
          key === 'channelPoundage' ||
          key === 'platformTradeAmount' ||
          key === 'platformPayAmount' ||
          key === 'platformRefundAmount'
        ) {
          data[key] = data[key].toFixed(2);
        }
      }
      state.recDetailTable = data;
    },
  },
  actions: {
    // 获取对账列表
    async getReconciliatList({ commit }, params = {}) {
      try {
        const result = await RECONCILIATION.getListByQuery(params);
        commit('settableData', result);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 获取对账详情
    async getDetail({ commit }, params = {}) {
      try {
        const result = await RECONCILIATION.getReconciliationDetail(params);
        commit('setrecDetailTable', result);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 重新对账
    async againReconciliation({ commit }, params = {}) {
      try {
        const result = await RECONCILIATION.updateReconciliation(params);
        commit(result);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
     // 重新对账
     async reWriteBills({ commit }, params = {}) {
      try {
        const result = await RECONCILIATION.reWriteBills(params);
        commit(result);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
  getters: {
    tableData: state => state.tableData,
    params: state => state.params,
    recDetailTable: state => state.recDetailTable,
    rightListMap: state => state.rightListMap,
  },
};

export default RECONCILIAT;
